// var description = document.querySelector('.collection-hero__description');
// var readMoreLink = document.getElementById('read-more-link');
// var expanded = false;

// function toggleContent() {
//   description.classList.toggle('expanded');
//   expanded = !expanded;

//   if (expanded) {
//     readMoreLink.textContent = 'Read Less';
//   } else {
//     readMoreLink.textContent = 'Read More';
//   }
// }

// readMoreLink.addEventListener('click', toggleContent);

var description = document.querySelector('.collection-hero__description');
var readMoreLink = document.getElementById('read-more-link');
var expanded = false;
var characterLimit = 550;
var originalHTML = description.innerHTML;

function toggleContent() {
  if (!expanded) {
    description.innerHTML = originalHTML;
    readMoreLink.textContent = 'Read Less';
  } else {
    var truncatedHTML = originalHTML.slice(0, characterLimit) + '...';
    description.innerHTML = truncatedHTML;
    readMoreLink.textContent = 'Read More';
  }

  expanded = !expanded;
}

function truncateText() {
  if (originalHTML.length > characterLimit) {
    var truncatedHTML = originalHTML.slice(0, characterLimit) + '...';
    description.innerHTML = truncatedHTML;
    readMoreLink.style.display = 'inline';
  } else {
    readMoreLink.style.display = 'none';
  }
}

readMoreLink.addEventListener('click', toggleContent);
window.addEventListener('DOMContentLoaded', truncateText);





